import envConfig from './environment';
import { getAppEnv } from './utils/getAppEnv';

const env = getAppEnv();

const {
  API_URL,
  STRIPE_KEY,
  ROOT_URL,
  SEGMENT_WRITE_KEY,
  STATIC_ASSET_HOST_URL,
  RECAPTCHA_SITE_KEY,
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
} = envConfig[env] || {};

const getApiUrl = () =>
  process.env.INTERNAL_API_URL || process.env.API_URL || API_URL;

const config = {
  apiUrlBase: getApiUrl(),
  apiUrlV2: `${getApiUrl()}/v2`,
  apiUrlV3: `${getApiUrl()}/v3`,
  apiUrlV4: `${getApiUrl()}/v4`,
  rootUrl: process.env.ROOT_URL || ROOT_URL,
  stripePubKey: STRIPE_KEY,
  staticAssetHostUrl: STATIC_ASSET_HOST_URL,
  recaptchaSiteKey: RECAPTCHA_SITE_KEY,
  analytics: {
    segmentWriteKey: SEGMENT_WRITE_KEY,
    datadogApplicationId: DATADOG_APPLICATION_ID,
    datadogClientToken: DATADOG_CLIENT_TOKEN,
  },
  isServer: typeof window === 'undefined',
  apiUrl: process.env.API_URL || API_URL,
};

export { config };
